/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

import gbcTemplates from "virtual:gbcTemplates"; // see vite-config plugins

modulum("TemplateService", ["InitService"], function (context, cls) {
  /**
   * Template management service
   * @namespace gbc.TemplateService
   * @gbcService
   */
  class TemplateService /** @lends gbc.TemplateService */ {
    constructor() {
      this._compiled = {};
      this._rendered = {};
    }

    init() {
      const tpl = window.gbcTemplates || gbcTemplates;

      if (Object.keys(tpl).length === 0) {
        console.debug("No template imported.");
      }

      const templateKeys = Object.keys(tpl);
      for (const templateId of templateKeys) {
        if (tpl.hasOwnProperty(templateId)) {
          this.registerRawTemplate(templateId, tpl[templateId]);
        }
      }
    }

    /**
     * Registers a new template (string) with the given id.
     * @param id the template id
     * @param template the template text
     */
    registerRawTemplate(id, template) {
      if (this._compiled[id]) {
        context.LogService.error("templateService.registerRawTemplate: template id already exists : " + id);
        return;
      }
      this._compiled[id] = template;
    }

    /**
     * Renders a node depending on the given template id.
     * @param templateId the template id to use for rendering
     * @returns string a string of the compiled template given the node and the template id
     */
    renderAs(templateId) {
      if (this._compiled.hasOwnProperty(templateId)) {
        return this._compiled[templateId];
      } else {
        return "";
      }
    }

    /**
     * Renders a node depending on the given template id.
     * @param templateId the template id to use for rendering
     * @param ascendance
     * @returns {Node} the compiled template given the node and the template id
     */
    renderDOM(templateId, ascendance) {
      if (this._rendered[templateId]) {
        return this._rendered[templateId].cloneNode(true);
      }

      const div = document.createElement("div");
      div.insertAdjacentHTML("beforeend", this.renderAs(templateId));
      const result = div.firstChild;
      const elements = div.querySelectorAll("*"),
        len = elements.length,
        attrNames = ascendance
          ? ascendance.map(function (item) {
              return "__" + item;
            })
          : ["__" + templateId],
        alen = attrNames.length;
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < alen; j++) {
          elements.item(i).setAttribute(attrNames[j], "");
        }
      }
      this._rendered[templateId] = result;
      if (!result) {
        console.debug("Cannot render template " + templateId);
      }
      return result?.cloneNode(true);
    }
  }

  gbc.TemplateService = new TemplateService();

  context.InitService.register(context.TemplateService);
});
